import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Code, ShoppingCart, Rocket, Building2, ArrowRight } from "lucide-react";

const solutions = [
  {
    id: "startups", icon: Rocket, title: "For Startups", color: "#00F3FF",
    desc: "Scale from MVP to millions of users without managing servers. Focus on your product.",
    useCases: ["Microservices", "API Backends", "High-Traffic SaaS"],
    link: "/cloud-hosting"
  },
  {
    id: "ecommerce", icon: ShoppingCart, title: "For E-Commerce", color: "#BC13FE",
    desc: "100% uptime during flash sales. PCI-compliant infrastructure optimized for WooCommerce & Magento.",
    useCases: ["WooCommerce", "Magento", "Payment Gateways"],
    link: "/wordpress-hosting"
  },
  {
    id: "agencies", icon: Building2, title: "For Agencies", color: "#00FF94",
    desc: "Host all your client websites under one dashboard. White-labeled. Blazing fast.",
    useCases: ["Client Portfolios", "WordPress Farms", "White-label Reselling"],
    link: "/vps-hosting"
  },
  {
    id: "developers", icon: Code, title: "For Developers", color: "#ffcc00",
    desc: "Root access, instant provisioning, and APIs. Your sandbox to build the future.",
    useCases: ["CI/CD Pipelines", "Docker Containers", "Game Servers"],
    link: "/vps-hosting"
  }
];

export default function Solutions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="solutions-page" className="page-enter pt-24">
      <section className="py-20 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h1 className="font-orbitron font-900 text-4xl lg:text-5xl text-white mb-6">
            Cloud Solutions for <br /><span className="text-gradient">Every Industry</span>
          </h1>
          <p className="font-outfit text-lg text-gray-400 mb-10">
            Whether you're bootstrapping a SaaS, running a media empire, or scaling an agency, 
            IndiaCloud provides the elastic infrastructure you need to win.
          </p>
        </div>
      </section>

      <section className="py-10 pb-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          {solutions.map((s) => (
            <div key={s.id} className="glass rounded-2xl p-8 flex flex-col h-full border hover:-translate-y-2 transition-transform duration-300"
              style={{ borderColor: `rgba(${s.color === "#00F3FF" ? "0,243,255" : s.color === "#BC13FE" ? "188,19,254" : s.color === "#00FF94" ? "0,255,148" : "255,204,0"}, 0.2)` }}>
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center shadow-lg"
                  style={{ background: `${s.color}20`, border: `1px solid ${s.color}40` }}>
                  <s.icon size={24} color={s.color} />
                </div>
                <h2 className="font-orbitron font-700 text-2xl text-white">{s.title}</h2>
              </div>
              <p className="font-outfit text-gray-400 mb-6 flex-1 text-sm leading-relaxed">{s.desc}</p>
              
              <div className="mb-8">
                <h4 className="font-rajdhani font-600 text-xs text-gray-500 uppercase tracking-widest mb-3">Popular Workloads</h4>
                <div className="flex flex-wrap gap-2">
                  {s.useCases.map(uc => (
                    <span key={uc} className="font-outfit text-xs px-3 py-1.5 rounded-full"
                      style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)" }}>
                      {uc}
                    </span>
                  ))}
                </div>
              </div>

              <Link to={s.link} className="mt-auto">
                <button className="w-full py-3 rounded-lg font-rajdhani font-700 text-sm tracking-wider flex items-center justify-center gap-2 transition-all duration-300"
                  style={{ background: `${s.color}15`, color: s.color, border: `1px solid ${s.color}30` }}>
                  VIEW INFRASTRUCTURE <ArrowRight size={14} />
                </button>
              </Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
